export default "__VITE_ASSET__DzmLd5MW__"